import React from 'react'
import Post from "./Post"



const Posts = ({posts,categorie}) => {
    return(
        <div className="columns is-multiline">
            {categorie ? posts && posts.map( ({node: post}) => {
                if(categorie === post.frontmatter.categorie){
                    return <Post post={post} key={post.id}/>
                }
                return ""
            } ) : posts && posts.reverse().map( ({node: post}) => <Post post={post} key={post.id} /> ) }
        </div>
    );
}

export default Posts